import { render } from "./AppointmentsView.vue?vue&type=template&id=5f63a29a&scoped=true"
import script from "./AppointmentsView.vue?vue&type=script&lang=js"
export * from "./AppointmentsView.vue?vue&type=script&lang=js"

import "./AppointmentsView.vue?vue&type=style&index=0&id=5f63a29a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f63a29a"]])

export default __exports__